/* SOLARA Bundle Builder — runtime
 * Finds every `.solara-bb` instance on the page and initializes each.
 * Each instance reads:
 *   - config from <script type="application/json" data-bb-config>
 *   - products from <script type="application/json" data-bb-products>
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    var $  = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // Config + products
    var CFG = {
      currency: 'AUD',
      discountPct: 0.05,
      discountMinItems: 3,
      freeShipMin: 150,
      bundleToken: 'BUNDLEBUILDER',
      bundleSlug: 'moto-camping'
    };
    var cfgEl = root.querySelector('[data-bb-config]');
    if (cfgEl) {
      try {
        var raw = JSON.parse(cfgEl.textContent || '{}');
        if (raw.currency)                 CFG.currency = raw.currency;
        if (raw.discountPct != null)      CFG.discountPct = Number(raw.discountPct);
        if (raw.discountMinItems != null) CFG.discountMinItems = Number(raw.discountMinItems);
        if (raw.freeShipMin != null)      CFG.freeShipMin = Number(raw.freeShipMin);
        if (raw.bundleToken)              CFG.bundleToken = raw.bundleToken;
        if (raw.bundleSlug)               CFG.bundleSlug = raw.bundleSlug;
      } catch (e) { console.warn('SOLARA bundle: bad config JSON', e); }
    }

    var products = [];
    var prodEl = root.querySelector('[data-bb-products]');
    if (prodEl) {
      try { products = JSON.parse(prodEl.textContent || '[]') || []; }
      catch (e) { console.error('SOLARA bundle: bad product JSON', e); return; }
    }

    // Build variant -> {product, variant} lookup map. Bundle is keyed by variant id.
    // Each variant has `available` (defaults to true if missing); a product is sold-out
    // when none of its variants are available.
    var variantMap = {};
    products.forEach(function (p) {
      var vs = p.variants && p.variants.length
        ? p.variants
        : [{ id: p.variant_id, title: '', price: p.price, available: p.available !== false }];
      vs.forEach(function (v) {
        var avail = v.available !== false; // default true
        variantMap[String(v.id)] = { product: p, variant: v, available: avail };
      });
    });
    function productAvailable(p) {
      var vs = p.variants && p.variants.length ? p.variants : [{ id: p.variant_id, available: p.available !== false }];
      return vs.some(function (v) { return v.available !== false; });
    }
    function firstAvailableVariant(p) {
      if (p.variants && p.variants.length) {
        var found = p.variants.find(function (v) { return v.available !== false; });
        return found || p.variants[0];
      }
      return { id: p.variant_id, title: '', price: p.price, available: p.available !== false };
    }

    // State + persistence (v2: keyed by variant id, not product id)
    var bundle = {};
    var filter = 'all';
    var sortBy = 'essential';
    var storageKey = 'solara-bundle-v2-' + CFG.bundleSlug;

    try {
      var saved = localStorage.getItem(storageKey);
      if (saved) bundle = JSON.parse(saved) || {};
    } catch (e) { bundle = {}; }
    Object.keys(bundle).forEach(function (vid) {
      if (!variantMap[vid]) delete bundle[vid];
    });

    function persist() {
      try { localStorage.setItem(storageKey, JSON.stringify(bundle)); } catch (e) {}
    }

    // Helpers
    function fmt(n) {
      return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
      });
    }
    function placeholderImg(title) {
      var initials = String(title).split(' ').slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase();
      return '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" aria-hidden="true">'
        + '<rect width="200" height="200" fill="#dcdcdc"/>'
        + '<g transform="translate(100,100)"><circle r="38" fill="rgba(255,255,255,.7)"/>'
        + '<text text-anchor="middle" dominant-baseline="central" font-family="ui-monospace, monospace" font-size="22" font-weight="700" fill="#0e0e0e">' + esc(initials) + '</text></g>'
        + '</svg>';
    }
    function catLabel(c) {
      return ({ cook:'Cook', eat:'Eat & Drink', sleep:'Sleep & Shelter', camp:'Camp', storage:'Storage', fuel:'Fuel' })[c] || (c || 'gear');
    }

    function entries() {
      return Object.keys(bundle).map(function (vid) {
        var entry = variantMap[vid];
        return entry ? { variantId: vid, product: entry.product, variant: entry.variant, qty: bundle[vid] } : null;
      }).filter(Boolean);
    }
    function totalItems()  { return entries().reduce(function (s, e) { return s + e.qty; }, 0); }
    function subtotal()    { return entries().reduce(function (s, e) { return s + e.variant.price * e.qty; }, 0); }
    function totalWeight() { return entries().reduce(function (s, e) { return s + (Number(e.product.weight_g) || 0) * e.qty; }, 0); }
    function fmtWeight(g)  {
      if (!g) return '0 g';
      if (g < 1000) return Math.round(g) + ' g';
      return (g / 1000).toFixed(2) + ' kg';
    }

    // Render: catalog grid
    function renderGrid() {
      var grid = $('[data-bb-grid]');
      if (!grid) return;
      grid.innerHTML = '';
      var list = products.slice();
      if (filter !== 'all') list = list.filter(function (p) { return p.category === filter; });
      if (sortBy === 'price-asc')  list.sort(function (a, b) { return a.price - b.price; });
      if (sortBy === 'price-desc') list.sort(function (a, b) { return b.price - a.price; });
      if (sortBy === 'weight-asc') list.sort(function (a, b) { return (a.weight_g || 9e9) - (b.weight_g || 9e9); });
      if (sortBy === 'essential')  list.sort(function (a, b) { return (b.essential ? 1 : 0) - (a.essential ? 1 : 0); });

      if (!list.length) {
        grid.innerHTML = '<div class="bb-empty">No products match this filter.</div>';
        return;
      }

      var frag = document.createDocumentFragment();
      list.forEach(function (p) {
        var hasMulti = p.variants && p.variants.length > 1;
        var prodAvail = productAvailable(p);
        var defaultVar = hasMulti ? firstAvailableVariant(p) : { id: p.variant_id, price: p.price, title: '', available: p.available !== false };
        var defaultAvail = defaultVar.available !== false;
        var currentVarId = String(defaultVar.id);
        var inB = !hasMulti && !!bundle[currentVarId];
        var qty = !hasMulti ? (bundle[currentVarId] || 0) : 0;

        var card = document.createElement('article');
        var classes = ['bb-card'];
        if (inB) classes.push('is-in-bundle');
        if (!prodAvail) classes.push('is-oos');
        card.className = classes.join(' ');
        card.setAttribute('data-product-id', p.id);
        card.setAttribute('data-variant-id', currentVarId);
        card.setAttribute('role', 'listitem');
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
          : placeholderImg(p.title);
        var weight = p.weight_g ? '<span class="bb-card-weight">' + p.weight_g + ' g</span>' : '';
        var tags = '';
        if (p.essential && prodAvail) tags += '<span class="bb-card-tag is-essential">Essential</span>';
        if (!prodAvail) tags += '<span class="bb-card-tag is-oos">Sold Out</span>';

        var variantSelect = '';
        if (hasMulti) {
          variantSelect = '<select class="bb-variant-select" data-variant-select aria-label="Choose ' + esc(p.option_name || 'option') + '">' +
            p.variants.map(function (v) {
              var vAvail = v.available !== false;
              var label = v.title + (vAvail ? '' : ' — Sold Out');
              return '<option value="' + esc(v.id) + '" data-price="' + v.price + '" data-available="' + (vAvail ? '1' : '0') + '"' +
                (vAvail ? '' : ' disabled') +
                (String(v.id) === currentVarId ? ' selected' : '') + '>' + esc(label) + '</option>';
            }).join('') +
          '</select>';
        }

        var addDisabled = !defaultAvail || !prodAvail ? ' disabled' : '';
        var addLabel = !prodAvail ? 'Sold Out' : '+ Add';

        card.innerHTML =
          '<div class="bb-card-img">' + img + tags + weight + '</div>' +
          '<div class="bb-card-body">' +
            '<div class="bb-card-cat">' + esc(catLabel(p.category)) + '</div>' +
            '<h3 class="bb-card-title">' + esc(p.title) + '</h3>' +
            '<p class="bb-card-blurb">' + esc(p.blurb || '') + '</p>' +
            variantSelect +
            '<div class="bb-card-foot">' +
              '<div class="bb-card-price"><span data-bb-card-price>' + fmt(defaultVar.price) + '</span><small>' + esc(CFG.currency) + '</small></div>' +
              '<button class="bb-add" type="button" data-action="add"' + addDisabled + ' aria-label="Add ' + esc(p.title) + ' to bundle">' + addLabel + '</button>' +
              (hasMulti ? '' :
                '<div class="bb-card-qty" role="group" aria-label="Quantity for ' + esc(p.title) + '">' +
                  '<button type="button" data-action="dec" aria-label="Decrease">−</button>' +
                  '<span class="bb-qty-val" data-qty>' + qty + '</span>' +
                  '<button type="button" data-action="inc" aria-label="Increase">+</button>' +
                '</div>') +
            '</div>' +
          '</div>';
        frag.appendChild(card);
      });
      grid.appendChild(frag);
    }

    // Render: bundle rail
    function renderRail() {
      var es = entries();
      var sub = subtotal();
      var count = totalItems();

      var countEl = $('[data-bb-count]'); if (countEl) countEl.textContent = count;
      var peekCountEl = $('[data-bb-peek-count]'); if (peekCountEl) peekCountEl.textContent = count;

      var itemsEl = $('[data-bb-items]');
      var emptyEl = $('[data-bb-empty]');
      if (itemsEl && emptyEl) {
        Array.prototype.slice.call(itemsEl.children).forEach(function (n) {
          if (n !== emptyEl) itemsEl.removeChild(n);
        });
        if (!es.length) {
          emptyEl.style.display = '';
        } else {
          emptyEl.style.display = 'none';
          var frag = document.createDocumentFragment();
          es.forEach(function (e) {
            var p = e.product;
            var v = e.variant;
            var item = document.createElement('div');
            item.className = 'bb-item';
            item.setAttribute('role', 'listitem');
            item.setAttribute('data-variant-id', e.variantId);
            var img = p.image
              ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" decoding="async">'
              : placeholderImg(p.title);
            var titleHtml = esc(p.title) + (v && v.title ? ' <span class="bb-item-variant">— ' + esc(v.title) + '</span>' : '');
            item.innerHTML =
              '<div class="bb-item-img">' + img + '</div>' +
              '<div class="bb-item-info">' +
                '<div class="bb-item-title">' + titleHtml + '</div>' +
                '<div class="bb-item-meta"><span>' + fmt(v.price) + '</span>' + (p.weight_g ? '<span>·</span><span>' + p.weight_g + ' g</span>' : '') + '</div>' +
              '</div>' +
              '<div class="bb-item-right">' +
                '<div class="bb-item-qty" role="group">' +
                  '<button type="button" data-action="dec" aria-label="Decrease">−</button>' +
                  '<span class="bb-qty-val" data-qty>' + e.qty + '</span>' +
                  '<button type="button" data-action="inc" aria-label="Increase">+</button>' +
                '</div>' +
                '<button class="bb-item-remove" type="button" data-action="remove" aria-label="Remove ' + esc(p.title) + '">Remove</button>' +
              '</div>';
            frag.appendChild(item);
          });
          itemsEl.appendChild(frag);
        }
      }

      var qDisc = count >= CFG.discountMinItems;
      var disc = qDisc ? sub * CFG.discountPct : 0;
      var afterDisc = sub - disc;
      var qShip = afterDisc >= CFG.freeShipMin;
      var total = afterDisc;

      var elSub = $('[data-bb-subtotal]');     if (elSub) elSub.textContent = fmt(sub);
      var elDisc = $('[data-bb-discount]');    if (elDisc) elDisc.textContent = '−' + fmt(disc);
      var elTot = $('[data-bb-total]');        if (elTot) elTot.textContent = fmt(total);
      var elPeekTotal = $('[data-bb-peek-total]'); if (elPeekTotal) elPeekTotal.textContent = fmt(total) + ' ' + CFG.currency;

      var rowDisc = $('[data-bb-row-discount]');
      var discLbl = $('[data-bb-discount-label]');
      var pctDisplay = Math.round(CFG.discountPct * 100);
      if (rowDisc && discLbl) {
        if (qDisc) {
          rowDisc.classList.remove('is-pending');
          discLbl.textContent = 'Bundle ' + pctDisplay + '% (auto)';
        } else {
          rowDisc.classList.add('is-pending');
          var need = Math.max(0, CFG.discountMinItems - count);
          discLbl.textContent = need === 0
            ? 'Bundle ' + pctDisplay + '%'
            : 'Add ' + need + ' more ' + (need === 1 ? 'item' : 'items') + ' for ' + pctDisplay + '% off';
        }
      }

      var strike = $('[data-bb-strike]');
      if (strike) {
        if (qDisc && count > 0) { strike.textContent = fmt(sub); strike.hidden = false; }
        else { strike.hidden = true; }
      }

      var savEl = $('[data-bb-savings]');
      if (savEl) savEl.textContent = disc > 0 ? 'You save ' + fmt(disc) : '';

      var tDisc = $('[data-bb-tier-discount]'); if (tDisc) tDisc.classList.toggle('is-hit', qDisc);
      var tShip = $('[data-bb-tier-shipping]'); if (tShip) tShip.classList.toggle('is-hit', qShip && count > 0);

      var s1 = $('[data-step="1"]'), s2 = $('[data-step="2"]'), s3 = $('[data-step="3"]');
      if (s1 && s2 && s3) {
        [s1, s2, s3].forEach(function (s) { s.classList.remove('is-active'); s.classList.remove('is-done'); });
        if (count === 0) s1.classList.add('is-active');
        else if (!qDisc && !qShip) { s1.classList.add('is-done'); s2.classList.add('is-active'); }
        else { s1.classList.add('is-done'); s2.classList.add('is-done'); s3.classList.add('is-active'); }
      }

      var cta = $('[data-bb-cta]');
      var ctaLbl = $('[data-bb-cta-label]');
      if (cta && ctaLbl) {
        if (count === 0) { cta.disabled = true; ctaLbl.textContent = 'Add at least 1 item'; }
        else { cta.disabled = false; ctaLbl.textContent = 'Add to Cart · ' + count + ' ' + (count === 1 ? 'item' : 'items') + ' · ' + fmt(total); }
      }

      var weightEl = $('[data-bb-weight]');
      if (weightEl) {
        var tw = totalWeight();
        weightEl.textContent = fmtWeight(tw);
        weightEl.classList.toggle('is-empty', tw === 0);
      }

      $$('.bb-card').forEach(function (c) {
        var vid = c.getAttribute('data-variant-id');
        // Multi-variant cards never enter "is-in-bundle" state (they have no inline qty stepper)
        if (c.querySelector('[data-variant-select]')) {
          c.classList.remove('is-in-bundle');
          return;
        }
        var q = bundle[vid] || 0;
        c.classList.toggle('is-in-bundle', q > 0);
        var qe = c.querySelector('.bb-card-qty [data-qty]');
        if (qe) qe.textContent = q;
      });
    }

    // Mutations — keyed by variant id (string)
    function add(vid, n) {
      n = n || 1;
      vid = String(vid);
      var prevCount = totalItems();
      var prevSub = subtotal();
      bundle[vid] = (bundle[vid] || 0) + n;
      if (bundle[vid] <= 0) delete bundle[vid];
      persist();
      var newCount = totalItems();
      var newSub = subtotal();
      var qDP = prevCount >= CFG.discountMinItems;
      var qDN = newCount  >= CFG.discountMinItems;
      if (!qDP && qDN) celebrate(Math.round(CFG.discountPct * 100) + '% bundle discount unlocked');
      var afterP = prevSub - (qDP ? prevSub * CFG.discountPct : 0);
      var afterN = newSub  - (qDN ? newSub  * CFG.discountPct : 0);
      if (afterP < CFG.freeShipMin && afterN >= CFG.freeShipMin) celebrate('FREE shipping unlocked');
      renderRail();
    }
    function remove(vid) { delete bundle[String(vid)]; persist(); renderRail(); }
    function setQty(vid, q) {
      vid = String(vid);
      if (q <= 0) delete bundle[vid]; else bundle[vid] = q;
      persist();
      renderRail();
    }

    // Toast + celebrate
    var toastTimer;
    function toast(msg) {
      var el = $('[data-bb-toast]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2200);
    }
    function celebrate(msg) {
      toast(msg);
      var rail = $('[data-bb-rail]');
      if (!rail) return;
      rail.classList.remove('is-celebrate');
      void rail.offsetWidth;
      rail.classList.add('is-celebrate');
    }

    // Events
    var grid = $('[data-bb-grid]');
    if (grid) {
      // Variant select change — update card's active variant id, displayed price, and Add state
      grid.addEventListener('change', function (ev) {
        var sel = ev.target.closest('[data-variant-select]');
        if (!sel) return;
        var card = ev.target.closest('.bb-card');
        if (!card) return;
        var vid = sel.value;
        card.setAttribute('data-variant-id', vid);
        var opt = sel.options[sel.selectedIndex];
        var price = opt ? Number(opt.getAttribute('data-price')) : null;
        var avail = opt ? opt.getAttribute('data-available') !== '0' : true;
        if (price != null) {
          var pe = card.querySelector('[data-bb-card-price]');
          if (pe) pe.textContent = fmt(price);
        }
        var addBtn = card.querySelector('.bb-add');
        if (addBtn) {
          addBtn.disabled = !avail;
          addBtn.textContent = avail ? '+ Add' : 'Sold Out';
        }
      });

      grid.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button[data-action]');
        if (!btn || btn.disabled) return;
        var card = ev.target.closest('.bb-card');
        if (!card) return;
        var vid = card.getAttribute('data-variant-id');
        var entry = variantMap[vid];
        if (!entry) return;
        if (!entry.available) return; // defensive: don't add OOS variants
        var p = entry.product;
        var v = entry.variant;
        var label = v.title ? (p.title + ' — ' + v.title) : p.title;
        var act = btn.getAttribute('data-action');
        if (act === 'add')      { add(vid, 1); toast(label + ' added'); }
        else if (act === 'inc') { add(vid, 1); }
        else if (act === 'dec') { var c = bundle[vid] || 0; if (c <= 1) remove(vid); else setQty(vid, c - 1); }
      });
    }

    var itemsEl2 = $('[data-bb-items]');
    if (itemsEl2) {
      itemsEl2.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button[data-action]');
        if (!btn) return;
        var item = ev.target.closest('.bb-item');
        if (!item) return;
        var vid = item.getAttribute('data-variant-id');
        var act = btn.getAttribute('data-action');
        if (act === 'remove')   { remove(vid); }
        else if (act === 'inc') { add(vid, 1); }
        else if (act === 'dec') { var c = bundle[vid] || 0; if (c <= 1) remove(vid); else setQty(vid, c - 1); }
      });
    }

    $$('.bb-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('.bb-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        filter = chip.getAttribute('data-filter');
        renderGrid();
        renderRail();
      });
    });

    var sortEl = $('[data-bb-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function (ev) {
        sortBy = ev.target.value;
        renderGrid();
        renderRail();
      });
    }

    function setRailOpen(open) {
      var rail = $('[data-bb-rail]');
      if (!rail) return;
      rail.classList.toggle('is-open', open);
      var peek = $('[data-bb-peek]');
      if (peek) peek.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    var peekBtn = $('[data-bb-peek]');
    if (peekBtn) {
      peekBtn.addEventListener('click', function () {
        var rail = $('[data-bb-rail]');
        if (!rail) return;
        setRailOpen(!rail.classList.contains('is-open'));
      });
    }

    var dragY = null;
    var railEl = $('[data-bb-rail]');
    if (railEl) {
      railEl.addEventListener('touchstart', function (ev) {
        if (!railEl.classList.contains('is-open')) return;
        var t = ev.touches[0];
        if (t && ev.target.closest('.bb-rail-handle, .bb-rail-head')) dragY = t.clientY;
      }, { passive: true });
      railEl.addEventListener('touchmove', function (ev) {
        if (dragY == null) return;
        var t = ev.touches[0];
        if (t && t.clientY - dragY > 40) { setRailOpen(false); dragY = null; }
      }, { passive: true });
      railEl.addEventListener('touchend', function () { dragY = null; });
    }

    var ctaBtn = $('[data-bb-cta]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var es = entries();
        if (!es.length) return;
        var qDisc = totalItems() >= CFG.discountMinItems;
        var attrs = {
          bundle: CFG.bundleSlug,
          bundle_items: String(totalItems()),
          bundle_discount: qDisc ? CFG.bundleToken : ''
        };
        var items = es.map(function (e) { return { id: Number(e.variantId) || e.variant.id, quantity: e.qty }; });
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          console.error('SOLARA bundle: cart add failed', err);
          toast('Could not add bundle. Please try again.');
        });
      });
    }

    renderGrid();
    renderRail();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.solara-bb')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor swaps section markup
  document.addEventListener('shopify:section:load', initAll);
})();
